const MASS_TO_KG: Record<string, number> = {
    kg: 1,
    g: 1e-3,
    mg: 1e-6,
};

const LENGTH_TO_M: Record<string, number> = {
    m: 1,
    dm: 1e-1,
    cm: 1e-2,
    mm: 1e-3,
};

function formatDensity(value: number): string {
    const rounded = Number(value.toFixed(6));
    return String(rounded);
}

export function convertDensityToKgPerDm3(density: string | null | undefined): string {
    if (!density) {
        return "";
    }

    const normalizedDensity = density
        .trim()
        .replaceAll("²", "^2")
        .replaceAll("³", "^3")
        .replace(/\s+/g, " ");

    const match = normalizedDensity.match(
        /^([+-]?\d+(?:[.,]\d+)?(?:e[+-]?\d+)?)\s*([a-zA-Z]+)\s*\/\s*([a-zA-Z]+)(?:\^(\d))?$/i
    );

    if (!match) {
        return density;
    }

    const numericValue = Number(match[1].replace(",", "."));
    const massUnit = match[2].toLowerCase();
    const lengthUnit = match[3].toLowerCase();
    const exponent = Number(match[4] ?? "3");

    const massFactor = MASS_TO_KG[massUnit];
    const lengthFactor = LENGTH_TO_M[lengthUnit];

    if (!Number.isFinite(numericValue) || !massFactor || !lengthFactor) {
        return density;
    }

    // Creo has been observed to return mm^2 for density in some cases. Treat it as mm^3.
    const safeExponent = exponent === 2 ? 3 : exponent;
    const volumeFactorToM3 = Math.pow(lengthFactor, safeExponent);

    if (safeExponent !== 3 || volumeFactorToM3 <= 0) {
        return density;
    }

    const densityInKgPerM3 = (numericValue * massFactor) / volumeFactorToM3;
    const densityInKgPerDm3 = densityInKgPerM3 * 1e-3;

    return `${formatDensity(densityInKgPerDm3)} kg/dm³`;
}
